export default __webpack_public_path__ + "static/media/withdraw-reward-step1.13bb0be4.png";